import React from 'react';
import { Card } from 'react-bootstrap';

function PriceCard({ tarifa, rate }) {
  if (!tarifa) return null;
  const { total, breakdown, surgeActive, surgeMultiplier } = tarifa;
  const totalNum = parseFloat(total) || 0;
  const vesTotal = rate ? (totalNum * rate).toFixed(2) : null;

  return (
    <Card className="border-0 shadow-sm rounded-16 overflow-hidden mb-3" style={{ background: 'var(--bry-bg-card, #FFFFFF)' }}>
      {/* Hero Header */}
      <div
        style={{
          background: 'linear-gradient(135deg, #0EABB0 0%, #088D91 100%)',
          padding: '20px 16px',
          color: '#ffffff',
          textAlign: 'center'
        }}
      >
        <span
          style={{
            opacity: 0.9,
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontWeight: 700,
            display: 'block',
            marginBottom: '4px'
          }}
        >
          Monto Total Estimado
        </span>
        <div className="d-flex align-items-center justify-content-center gap-2">
          <span style={{ fontSize: '32px', fontWeight: 800, letterSpacing: '-0.5px' }}>
            ${totalNum.toFixed(2)}
          </span>
          <span style={{ fontSize: '14px', fontWeight: 700, opacity: 0.9 }}>
            USD
          </span>
        </div>
        {vesTotal && (
          <div
            className="mt-2 d-inline-block px-3 py-1 rounded-pill"
            style={{
              background: 'rgba(255, 255, 255, 0.22)',
              fontSize: '13px',
              fontWeight: 700,
              backdropFilter: 'blur(4px)'
            }}
          >
            Aprox. Bs. {vesTotal} (VES)
          </div>
        )}
      </div>

      {/* Breakdown Details */}
      <Card.Body className="p-3" style={{ backgroundColor: '#FAFBFD' }}>
        <div className="d-flex justify-content-between text-center gap-2">
          <div className="flex-fill p-2 rounded-12 bg-white border" style={{ borderColor: '#E2E8F0' }}>
            <small className="text-muted d-block" style={{ fontSize: '11px', fontWeight: 600 }}>Base</small>
            <strong style={{ fontSize: '14px', color: '#0F172A' }}>
              ${Number(breakdown?.base || 0).toFixed(2)}
            </strong>
          </div>
          <div className="flex-fill p-2 rounded-12 bg-white border" style={{ borderColor: '#E2E8F0' }}>
            <small className="text-muted d-block" style={{ fontSize: '11px', fontWeight: 600 }}>Distancia</small>
            <strong style={{ fontSize: '14px', color: '#0F172A' }}>
              ${Number(breakdown?.distancia || 0).toFixed(2)}
            </strong>
          </div>
          <div className="flex-fill p-2 rounded-12 bg-white border" style={{ borderColor: '#E2E8F0' }}>
            <small className="text-muted d-block" style={{ fontSize: '11px', fontWeight: 600 }}>Tiempo</small>
            <strong style={{ fontSize: '14px', color: '#0F172A' }}>
              ${Number(breakdown?.tiempo || 0).toFixed(2)}
            </strong>
          </div>
          {breakdown?.gasolina > 0 && (
            <div className="flex-fill p-2 rounded-12 bg-white border" style={{ borderColor: '#E2E8F0' }}>
              <small className="text-muted d-block" style={{ fontSize: '11px', fontWeight: 600 }}>Gasolina</small>
              <strong style={{ fontSize: '14px', color: '#0F172A' }}>
                ${Number(breakdown.gasolina).toFixed(2)}
              </strong>
            </div>
          )}
        </div>

        {(breakdown?.factorPeso > 1 || surgeActive) && (
          <div className="border-top pt-2 mt-3" style={{ fontSize: '13px' }}>
            {breakdown?.factorPeso > 1 && (
              <div className="d-flex justify-content-between text-muted py-1">
                <span>Multiplicador por peso ({breakdown.factorPeso}x)</span>
                <span className="fw-bold" style={{ color: '#0EABB0' }}>Aplicado</span>
              </div>
            )}
            {surgeActive && (
              <div className="d-flex justify-content-between text-muted py-1">
                <span>Alta demanda (x{surgeMultiplier})</span>
                <span className="fw-bold text-warning">+{breakdown?.surge ? `$${breakdown.surge.toFixed(2)}` : 'Dinámica'}</span>
              </div>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default PriceCard;
